<div [formGroup]="myFormGroup">
  <lib-meta-select-input
    (ngModelChange)="salesPersonSelected($event)"
    formControlName="saljare"
    table="salj"
    metaId="saljare"
    metaDisplay="saljarenamn"
  >
  </lib-meta-select-input>
</div>
<hr />
